<template>
  <div>
    <!-- Page length options -->
    <div class="card mb-0">
      <div
        v-show="onload"
        class="content bg-white"
      >
        <placeholder-content is-load="true" />
      </div>
      <div v-if="!onload && hasPermission">
        <access-denied />
      </div>
      <div
        v-show="!onload && !hasPermission"
        class="card-header border-bottom"
      >
        <div class="row">
          <div class="col-6">
            <h5 class="card-title">
              {{ $t("Shipping Charge Billing Report Detail") }}
              <a
                style="color:#706F72;"
                class="ml-1"
                data-trigger="hover"
                data-popup="popover-custom"
                data-placement="top"
                :title="$t('Suggestion')"
                :data-content="$t('Summary of all shipping costs for shipment, search by generate tracking date. Consisting of shipping costs, COD fees, remote area fees, tourism area fees.Note: Actual shipping costs can be adjusted after the carrier imports your shipment into the carriers system.')"
              >
                <i class="fas fa-info-circle" />
              </a>
            </h5>
          </div>
        </div>
      </div>
      <div
        v-show="!onload && !hasPermission"
        class="card-body p-0"
      >
        <div v-show="!onload">
          <div class="flex-wrap">
            <shipping-expenses-detail-table />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { convertTimezone } from "@/common/tenancy/convertTimezone";
  import PlaceholderContent from "@/plugins/PlaceholderContent.vue";
  import ShippingExpensesDetailTable from "./ShippingExpensesDetailTable.vue";
  import AccessDenied from "@/components/tenancy/admin/error-page/templates/AccessDenied.vue";
  export default {
    name: "ShippingExoebsesDeail",
    components: {
      PlaceholderContent,
      ShippingExpensesDetailTable,
      AccessDenied,
    },
    data() {
      return {
        onload: true,
        hasPermission: true,
      };
    },
    updated() {
      $('[data-popup=popover-custom]').popover({
        template: '<div class="popover border-light"><div class="arrow"></div><p class="popover-header bg-light text-dark font-weight-bold"></p><div class="popover-body"></div></div>'
      });
    },
    methods: {
      formatJson(filterValShipping, jsonData) {
        return jsonData.map(v => filterValShipping.map(j => {
          const jArr = j.split('.');
          if( jArr.length > 1){
            return v[jArr[0]][[jArr[1]]];
          }

          if (j === 'timestamp') {
            return parseTime(v[j])
          }else {
            return v[j]
          }
        }))
      },
      convertTimezone(date) {
        return date != null && new Date(date) instanceof Date && !isNaN(new Date(date)) ? convertTimezone.utcToLocal(date) : '-';
      },
    }
  };
</script>
<style>
  .header-title {
    margin-bottom: 0.1rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/tenancy/admin/report/finance/ShippingExpensesDetail.vue